import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseQueryParams, DynaDocsDto, DynaDocsResponse, DynaFields, DynaFieldsRequest, PageResponse, TemplateResponse, TemplatePlaceholders } from '@/types';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

type DcocumentDynamicQuery = BaseQueryParams;

@Injectable({
  providedIn: 'root',
})
export class DocumentDynamicsService {
  BASEURL = `${environment.api.dacUrl}`;
  httpClient = inject(HttpClient);

  getDynaDocs({ page, size, search, sort, filter }: DcocumentDynamicQuery): Observable<PageResponse<DynaDocsResponse>> {
    let params = new HttpParams();
    // if (name) params = params.set('name', name);
    // if (templateFileName) params = params.set('templateFileName', templateFileName);
    // if (guideFileName) params = params.set('guideFileName', guideFileName);
    // if (status !== undefined) params = params.set('status', status.toString());
    // if (typeMarcheId !== undefined) params = params.set('typeMarcheId', typeMarcheId.toString());
    if (page) params = params.set('page', page.toString());
    if (size) params = params.set('size', size.toString());
    if (search) params = params.set('search', search);
    if (sort) params = params.set('sort', sort);
    if (filter) params = params.set('filter', filter);

    return this.httpClient.get<PageResponse<DynaDocsResponse>>(`${this.BASEURL}/dyna-docs`, { params });
  }

  getDynaDocsById(dynaDocsId: number, version?: number): Observable<DynaDocsResponse> {
    let params = new HttpParams();
    params = params.set('withFields', 'true');
    if (version !== undefined) params = params.set('version', version.toString());

    return this.httpClient.get<DynaDocsResponse>(`${this.BASEURL}/dyna-docs/${dynaDocsId}`, { params });
  }

  createDynaFields(dynaFieldsRequest: DynaFieldsRequest): Observable<DynaFields> {
    return this.httpClient.post<DynaFields>(`${this.BASEURL}/dyna-fields`, dynaFieldsRequest);
  }

  updateDynaFields(dynaFieldId: number, dynaFieldsRequest: DynaFieldsRequest): Observable<DynaFields> {
    return this.httpClient.put<DynaFields>(`${this.BASEURL}/dyna-fields/${dynaFieldId}`, dynaFieldsRequest);
  }

  deleteDynaFields(dynaFieldId: number): Observable<DynaFields> {
    return this.httpClient.delete<DynaFields>(`${this.BASEURL}/dyna-fields/${dynaFieldId}`);
  }
  createDynaDocs(dynaDocsDto: DynaDocsDto): Observable<DynaDocsResponse> {
    return this.httpClient.post<DynaDocsResponse>(`${this.BASEURL}/dyna-docs`, dynaDocsDto);
  }

  updateDynaDoc(dynaDocId: number, dynaDocsDto: DynaDocsDto): Observable<DynaDocsResponse> {
    return this.httpClient.put<DynaDocsResponse>(`${this.BASEURL}/dyna-docs/${dynaDocId}`, dynaDocsDto);
  }

  // Templates endpoints
  getTemplates(): Observable<TemplateResponse[]> {
    return this.httpClient.get<TemplateResponse[]>(`${this.BASEURL}/templates`);
  }

  getTemplate(templateName: string): Observable<TemplateResponse> {
    return this.httpClient.get<TemplateResponse>(`${this.BASEURL}/templates/${templateName}`);
  }

  uploadTemplate(file: File): Observable<TemplateResponse> {
    const formData = new FormData();
    formData.append('file', file);
    return this.httpClient.post<TemplateResponse>(`${this.BASEURL}/templates/upload`, formData).pipe(
      catchError(error => {
        console.error('Upload failed:', error);
        return throwError(() => new Error('Template upload failed'));
      })
    );
  }

  deleteTemplate(templateName: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.BASEURL}/templates/${templateName}`);
  }

  extractPlaceholders(templateName: string): Observable<TemplatePlaceholders> {
    return this.httpClient.get<TemplatePlaceholders>(`${this.BASEURL}/templates/${templateName}/placeholders`);
  }

  downloadTemplate(templateName: string): Observable<Blob> {
    return this.httpClient
      .get(`${this.BASEURL}/templates/${templateName}/download`, {
        responseType: 'blob',
      })
      .pipe(
        tap((blob: Blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = templateName;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        })
      );
  }
}
